// extracted by mini-css-extract-plugin
module.exports = {"ResourceAdminPage":"ResourceAdminPage_ResourceAdminPage__23TaK"};